import { Outlet, useParams } from "react-router-dom";
import { PaymentProvider } from "../context/paymentContext";
import { SchoolFeeProvider } from "../context/schoolFeeContext";

/**
 * The parent route of one service's journey and its outcome page. The
 * journey state lives here, in memory only, so a failed payment can return
 * to its review step with every entry kept. Keyed by the service, so
 * choosing another one starts empty; leaving for the home page unmounts it.
 */
export const JourneyScope = () => {
  const { id = "" } = useParams();
  return (
    <PaymentProvider key={id}>
      <SchoolFeeProvider>
        <Outlet />
      </SchoolFeeProvider>
    </PaymentProvider>
  );
};

export default JourneyScope;
